@if (parameters$ | async; as parameters) {
	<section class="container flex">
		<div class="geometric-figures">
			<img src="assets/images/geometric-figures.svg" alt="geometric figures" />
		</div>
		<div>
			<p bciWkTypeH1100 class="title text" [innerHTML]="parameters.title"></p>
		</div>
	</section>
}
